import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import Stand from '../../images/stand.svg'
import Filter5Icon from '@mui/icons-material/Filter5';
import DangerousIcon from '@mui/icons-material/Dangerous';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ReplayIcon from '@mui/icons-material/Replay';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import NotificationsPausedIcon from '@mui/icons-material/NotificationsPaused';
import GrassIcon from '@mui/icons-material/Grass';
import MoveDownIcon from '@mui/icons-material/MoveDown';

import { Link } from 'react-router-dom'
import { Battery0Bar, DateRange } from '@mui/icons-material';
const moment=require('moment-jalaali')

const LogList = ({item}) => {
    const {logTime}=item;
    const pbirth=moment(logTime).format('jYYYY-jMM-jDD HH:mm:ss')
  return (
    <div className='  col-sm-12 col-md-12 col-lg-4    gap-3'>
                <div  className='ThemeCard2' data-aos="zoom-out-down" >
     <Row className='d-flex gap-2'>
        <Col sm='6'>
        <div className='ThemeCardItem '>
        <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div>
                <span>زمان لاگ</span>
                <span style={{fontSize:'9px',wordBreak:'break-all'}}>{pbirth}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Filter5Icon/>
                </span>
                    </div></div>
                <span> تعداد پکت ها :</span>
                <span style={{fontSize:'9px'}}>{item?.packetCounter}</span>
            </div>
            
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Battery0Bar/>
                </span>
                    </div></div>
                <span>  باتری :</span>
                <span>{item?.batteryLevel}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <WaterDropIcon/>
                </span>
                    </div></div>
                <span> رطوبت  :</span>
                <span>{item?.humidity}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DeviceThermostatIcon/>
                </span>
                    </div></div> 
                <span> دما :</span>
                <span>{+item?.temperature}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <TrendingUpIcon/>
                </span>
                    </div></div> 
                <span> فعالیت :</span>
                <span>{+item?.activity}</span>
            </div>
           
        </Col>
        <Col sm='6' >
        <div className='ThemeCardItem'>
        <div className='LogoFormT'><div><span>
                <StackedLineChartIcon/>
                </span>
                    </div></div>
                <span> استرس :</span>
                <span>{item?.unrest}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <GrassIcon/>
                </span>
                    </div></div>
                <span> جویدن :</span>
                <span>{item?.chewing}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <GrassIcon/>
                </span>
                    </div></div>
                <span> نشخوار :</span>
                <span>{item?.rumination}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <NotificationsPausedIcon/>
                </span>
                    </div></div> 
                <span> خواب :</span>
                <span>{item?.sleeping}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
            <img style={{width:'20px',height:'20px'}}  src={Stand} width={20} height={20}/> 
                </span>
                    </div></div>
                 
                <span> ایستادن :</span>
                <span>{item?.standing}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <MoveDownIcon/>
                </span>
                    </div></div> 
                <span> راه رفتن :</span>
                <span>{item?.walking}</span>
            </div>
        </Col>
    </Row>
    </div>
    </div>
  )
}

export default LogList
